import { ICreatorTheme } from "../../../../../features/Common/modules/Theme/theme.interface";
import { getColorsFromCreatorTheme } from "../../../../../features/Common/modules/Theme/utils/Theme.utils";
import { getStylesObjFromCss } from "../../../../../utils/common/styling";

export const styles = getStylesObjFromCss({
  styles: {
    repliesContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      marginBottom: "4px",
      marginTop: "10px",
    },
    loadMoreRepliesBtn: {
      display: "flex",
      alignItems: "center",
      fontSize: "14px",
      marginBottom: "12px !important",
    },
  },
  componentName: "Replies",
});

export const getThemedStyles = ({ theme }: { theme: ICreatorTheme }) => {
  const { color1 } = getColorsFromCreatorTheme(theme);
  return getStylesObjFromCss({
    styles: {
      loadMoreRepliesBtn: {
        color: (color1 || "#493AB1") + " !important",
      },
    },
    componentName: "Replies",
  });
};
